/* eslint-disable no-new */
export default {
    selectTransfer({ commit }, item) {
        new Promise(resolve => {
            commit('SET_TRANSFER_SELECTED', item);
            resolve();
        });
    },
    setMargin({ commit }, value) {
        new Promise(resolve => {
            commit('SET_MARGIN', value);
            resolve();
        });
    },
    removeTransfer({ commit }, item) {
        new Promise(resolve => {
            commit('REMOVE_TRANSFER', item);
            resolve();
        });
    },
    removeOperation({ commit }, item) {
        new Promise(resolve => {
            commit('REMOVE_OPERATION', item);
            resolve();
        });
    },
    removeTransfersSelected({ commit }) {
        new Promise(resolve => {
            commit('REMOVE_TRANSFERS_SELECTED');
            resolve();
        });
    },
    selectOperation({ commit }, item) {
        new Promise(resolve => {
            commit('SET_OPERATION_SELECTED', item);
            resolve();
        });
    },
    removeOperationsSelected({ commit }) {
        new Promise(resolve => {
            commit('REMOVE_OPERATIONS_SELECTED');
            resolve();
        });
    },
    setGroupedSelected({ commit }, value) {
        new Promise(resolve => {
            commit('SET_GROUPED_SELECTED', value);
            resolve();
        });
    },
    setUuidGroupedSelected({ commit }, value) {
        new Promise(resolve => {
            commit('SET_UUID_GROUPED_SELECTED', value);
            resolve();
        });
    },
    setSuggestions({ commit }, value) {
        new Promise(resolve => {
            commit('SET_SUGGESTIONS', value);
            resolve();
        });
    },
    disableGroups({ commit }, value) {
        new Promise(resolve => {
            commit('SET_DISABLE_GROUPS', value);
            resolve();
        });
    },
    setComment({ commit }, value) {
        new Promise(resolve => {
            commit('SET_COMMENT', value);
            resolve();
        });
    },
    setSearchBy({ commit }, value) {
        new Promise(resolve => {
            commit('SET_SEARCHBY', value);
            resolve();
        });
    },
    disableAll({ commit }, value) {
        new Promise(resolve => {
            commit('SET_DISABLEALL', value);
            resolve();
        });
    }
};
